import { render, staticRenderFns } from "./LabsDetailsTab.vue?vue&type=template&id=66a4b0a4&scoped=true&"
import script from "./LabsDetailsTab.vue?vue&type=script&lang=js&"
export * from "./LabsDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4b0a4",
  null
  
)

export default component.exports